import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/i18n';

import { LoginPageComponent } from './login-page/login-page.component';
import { ForgotPwdPageComponent } from './forgot-pwd-page/forgot-pwd-page.component';
import { ResetPwdComponent } from './reset-pwd/reset-pwd.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ActivateComponent } from './activate/activate.component';
import { TokenExpiredComponent } from './token-expired/token-expired.component';

const routes: Routes = [
  { path: 'login', component: LoginPageComponent, data: { title: extract('Login') } },
  { path: 'logout', redirectTo: 'login' },
  { path: 'forgot-pwd', component: ForgotPwdPageComponent, data: { title: extract('ForgotPwd') } },
  { path: 'reset-pwd', component: ResetPwdComponent, data: { title: extract('ResetPwd') } },
  { path: 'change-password', component: ChangePasswordComponent, data: { title: extract('ChangePassword') } },
  { path: 'activate', component: ActivateComponent, data: { title: extract('Activate') } },
  { path: 'token-expired', component: TokenExpiredComponent, data: { title: extract('TokenExpired') } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AuthRoutingModule {}
